import { render, staticRenderFns } from "./formCapsule.vue?vue&type=template&id=f8c5a45a&"
import script from "./formCapsule.vue?vue&type=script&lang=js&"
export * from "./formCapsule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports